import { TableHeader } from "../../commons";
import InfiniteLoader from "../../commons/InfiniteLoader/InfiniteLoader";
import ScrollToTop from "../../commons/ScrollToTop";
import AllUserApprovedEntryTableData from "./AllUserApprovedEntryTableData";
import { ALL_USER_APPROVED_ENRTY_LIST_HEADERS } from "../../../constant/tableHeadersConstants/allUserApprovedEntryCountConstants";
import { AllUserApprovedEntryListType } from "../../../redux/listing/listingTypes";

type AppProps = {
  fetching: boolean;
  offset: number;
  data: AllUserApprovedEntryListType[] | [];
};

const AllUserApprovedEntryTable = ({ fetching, offset, data }: AppProps) => {
  return (
    <div className="jobsType" style={{ overflowX: "scroll" }}>
      <table className="table thead-light table-bordered">
        <thead className="text-start sticky-table-header">
          <TableHeader tableHeader={ALL_USER_APPROVED_ENRTY_LIST_HEADERS} />
        </thead>
        <tbody>
          <AllUserApprovedEntryTableData
            data={data}
            tableHeader={ALL_USER_APPROVED_ENRTY_LIST_HEADERS}
          />
          {fetching && offset > 0 && <div>{<InfiniteLoader />}</div>}
          <div style={{ display: fetching ? "none" : "inline" }}>
            <ScrollToTop />
          </div>
        </tbody>
      </table>
    </div>
  );
};

export default AllUserApprovedEntryTable;
